import { ContactBlock as ContactBlockTypes } from '@/payload-types'
import { Media } from '@onclicks/sharedcomponents/Media/Media'
import { barlow } from '@/utilities/fontImport'
import { cn } from '@/utilities/ui'
import { ContactPanelBlock } from './ContactPanelBlock'
import { FormBlock } from './FormBlock'

const ContactMainContainerBlock: React.FC<ContactBlockTypes> = (props) => {
  const { content, title, subtitle, showBackgroundImage, backgroundImage } = props

  if (!content || content.length === 0) return null

  const hasBackgroundImage =
    showBackgroundImage && backgroundImage && typeof backgroundImage === 'object'
  const blocks = content.filter(
    (block) => block.blockType === 'formBlock' || block.blockType === 'cPanel',
  )

  return (
    <section
      className={cn(
        'relative isolate w-full overflow-hidden px-4 py-12 md:px-12',
        !hasBackgroundImage && 'bg-linear-to-b from-[#567186] to-[#AFB1AB]',
        barlow.className,
      )}
    >
      {hasBackgroundImage && (
        <>
          <Media
            resource={backgroundImage}
            fill
            imgClassName="object-cover"
            className="absolute inset-0 -z-20"
          />
          <div className="absolute inset-0 -z-10 bg-linear-to-b from-[#2A2D3F]/80 to-black/80" />
        </>
      )}

      {(title || subtitle) && (
        <div className="mx-auto mb-6 flex max-w-[65ch] flex-col items-center text-center text-white">
          {title && <h1 className="font-bold">{title}</h1>}
          <span className="my-5 block h-px w-32 bg-primary" />
          {subtitle && <p className="text-white/90">{subtitle}</p>}
        </div>
      )}

      <div className="container grid grid-cols-1 gap-5 lg:grid-cols-3">
        {blocks.map((block, index) => (
          <div
            key={block.id ?? index}
            className={cn(
              blocks.length === 1
                ? 'lg:col-span-3'
                : index === 0
                  ? 'lg:col-span-1'
                  : 'lg:col-span-2',
            )}
          >
            {block.blockType === 'formBlock' && <FormBlock {...block} />}
            {block.blockType === 'cPanel' && <ContactPanelBlock {...block} />}
          </div>
        ))}
      </div>
    </section>
  )
}

export { ContactMainContainerBlock }
